import React from "react";

// 1. We receive the 'onAssetClick' prop from the parent
const Matrix = ({ data, onAssetClick }) => {
  if (!data) return null;

  const getStatusColor = (status) => {
    switch (status) {
      case "ready": return "#DCFCE7";
      case "building": return "#FEF9C3";
      default: return "#F1F5F9";
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case "ready": return "#166534";
      case "building": return "#854D0E";
      default: return "#64748B";
    }
  };

  return (
    <div style={{ overflowX: "auto", border: "1px solid #e2e8f0", borderRadius: "12px" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "600px" }}>
        <thead>
          <tr style={{ background: "#f8fafc", borderBottom: "2px solid #e2e8f0" }}>
            <th style={{ padding: "1rem", textAlign: "left", width: "20%" }}>Learner Role</th>
            {data.columns.map((col, i) => (
              <th key={i} style={{ padding: "1rem", textAlign: "left", color: "#7C3AED" }}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.rows.map((row, i) => (
            <tr key={i} style={{ borderBottom: "1px solid #e2e8f0" }}>
              {/* Role Column */}
              <td style={{ padding: "1rem", background: "#f8fafc", borderRight: "1px solid #e2e8f0" }}>
                <div style={{ fontWeight: "700", color: "#0f172a" }}>{row.role}</div>
                <div style={{ fontSize: "0.8rem", color: "#64748b", fontStyle: "italic" }}>Focus: {row.focus}</div>
              </td>

              {/* Asset Columns */}
              {row.assets.map((asset, j) => (
                <td key={j} style={{ padding: "1rem", verticalAlign: "top" }}>
                  <div 
                    // 2. CRITICAL FIX: This 'onClick' fires the function passed from the page
                    onClick={() => {
                      if (onAssetClick) {
                        onAssetClick(asset);
                      }
                    }}
                    style={{ 
                      border: "1px solid #e2e8f0", 
                      borderRadius: "8px", 
                      padding: "0.75rem", 
                      background: "#fff",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                      cursor: "pointer", // 3. VISUAL FIX: Makes the cursor a hand pointer
                      transition: "all 0.2s ease"
                    }}
                    // 4. VISUAL FIX: Adds a "lift" effect on hover so you know it's clickable
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-3px)";
                      e.currentTarget.style.boxShadow = "0 10px 15px -3px rgba(0, 0, 0, 0.1)";
                      e.currentTarget.style.borderColor = "#7C3AED";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 1px 2px rgba(0,0,0,0.05)";
                      e.currentTarget.style.borderColor = "#e2e8f0";
                    }}
                  >
                    <div style={{ 
                      fontSize: "0.7rem", 
                      textTransform: "uppercase", 
                      letterSpacing: "0.05em", 
                      color: "#94a3b8", 
                      marginBottom: "0.25rem" 
                    }}>
                      {asset.type}
                    </div>
                    <div style={{ fontWeight: "600", fontSize: "0.9rem", marginBottom: "0.5rem", color: "#334155" }}>
                      {asset.title}
                    </div>
                    {/* Status Pill */}
                    <span style={{ 
                      fontSize: "0.7rem", 
                      padding: "0.15rem 0.5rem", 
                      borderRadius: "99px", 
                      background: getStatusColor(asset.status),
                      color: getStatusText(asset.status),
                      fontWeight: "700",
                      textTransform: "uppercase"
                    }}>
                      {asset.status}
                    </span>
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Matrix;
